domReady(() => {
  const getYouTubeID = (url) => {
    const parts = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
    return parts[2] ? parts[2].split(/[^0-9a-z_\-]/i)[0] : parts[0];
  };

  const addDays = (date, days) => {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  };

  const getDaySuffix = (day) => {
    if (day >= 11 && day <= 13) return "th";
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  const formatDate = (date) => {
    const d = new Date(date);
    const day = d.getDate();
    const month = d.toLocaleString("default", { month: "short" });
    const year = d.getFullYear();
    return `${day}${getDaySuffix(day)} ${month} ${year}`;
  };

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  // -----------------------
  // Main logic
  // -----------------------
  const orderDetails = window.sessionStorage.getItem("__custom_order");
  if (!orderDetails) return;

  const products = JSON.parse(orderDetails);
  const { shopify_order, status_history } = products;

  // Order Info
  const createdAt = new Date(shopify_order.created_at);
  $("#order_date").html(
    `${createdAt.getDate()}/${createdAt.getMonth() + 1}/${createdAt.getFullYear()}`,
  );
  $("#order_id").html(`Order ID: #${products.order_number}`);
  $("#order_total").html(`₹ ${shopify_order.current_total_price}`);

  // -----------------------
  // Line Items
  // -----------------------
  const lineItemsHTML = shopify_order.line_items
    .map((item) => {
      const props = item.properties
        .map((p) => `<li>${p.name}: ${p.value}</li>`)
        .join("");
      return `
      <div class="item">
        <div class="item-left-col">
          <div class="text-wrap">
            <p>${item.name} x ${item.quantity}</p>
            <label class="toggle-btn">See customisations</label>
            <ul class="order-customisation">${props}</ul>
          </div>
        </div>
        <div class="item-right-col"><p>₹ ${item.price}</p></div>
      </div>`;
    })
    .join("");
  $("#order_items").html(lineItemsHTML);

  // -----------------------
  // Order Status
  // -----------------------
  const areAllReadyMade = shopify_order.line_items.every((item) => {
    const properties = item.properties || [];

    const lineItemType = properties.find((p) => p.name === "_lineitem_type");
    const template = properties.find((p) => p.name === "template");

    const title = item.title.toLowerCase();
    const isBelt = title.includes("belt"); // covers belt / belts

    // If we have an explicit type, use it
    if (lineItemType) {
      return lineItemType.value === "ready-made";
    }

    // If we have "template: ready-made"
    if (template) {
      return template.value === "ready-made";
    }

    // No type/template → treat belts as ready-made
    return isBelt;
  });

  console.log("areAllReadyMade", areAllReadyMade);

  // A "physical gift" line item (the Physical Gift Card product) is the only
  // product type that collects a "Shipping Address" line item property —
  // the digital gift card shares every other recipient/sender field but not
  // this one (see snippets/product-form.liquid). Use that as the signal.
  const hasPhysicalGiftProduct = shopify_order.line_items.some((item) => {
    const properties = item.properties || [];
    return properties.some(
      (p) => p.name === "Shipping Address" && p.value,
    );
  });

  console.log("hasPhysicalGiftProduct", hasPhysicalGiftProduct);

  // A digital gift card line item is emailed, not shipped, so it never
  // collects a "Shipping Address" property — that's what tells it apart
  // from the physical one above. It's identified by Shopify's own
  // `gift_card` flag on the line item, or (as a fallback) the
  // `_gift_card_variant_id` property set by
  // snippets/gift-card-recipient-form.liquid.
  const hasDigitalGiftProduct = shopify_order.line_items.some((item) => {
    const properties = item.properties || [];
    const isGiftCard =
      item.gift_card === true ||
      properties.some((p) => p.name === "_gift_card_variant_id" && p.value);
    const hasShippingAddress = properties.some(
      (p) => p.name === "Shipping Address" && p.value,
    );
    return isGiftCard && !hasShippingAddress;
  });

  console.log("hasDigitalGiftProduct", hasDigitalGiftProduct);

  // Both gift-card formats skip the tailoring timeline entirely — a digital
  // card is emailed and a physical one ships as-is, neither is custom-made —
  // so they share the same collapsed "Order Received" + "Order Dispatched"
  // view below.
  const isGiftCardOrder = hasPhysicalGiftProduct || hasDigitalGiftProduct;

  const shipmentContainsCustomMade = shopify_order.fulfillments.find((f) =>
    f.line_items.some((item) =>
      item.properties.some(
        (p) => p.name === "_lineitem_type" && p.value === "custom-made",
      ),
    ),
  );

  const shipmentStatus = shipmentContainsCustomMade
    ? shipmentContainsCustomMade?.shipment_status
    : shopify_order.fulfillments[0]?.shipment_status || null;

  console.log("shipmentContainsCustomMade", shipmentContainsCustomMade);

  const statusToRemove = [
    "ORDER SHEET HANDOVER TO PATTERN MASTER",
    "CUTTING + POCKETING + FUSING",
    "SEWING",
    "FINAL CHECK",
    "PACKING",
  ];

  const shippingStatusContent = {
    attempted_delivery: "A delivery attempt was made for your order.",
    delivered: "Your order has been successfully delivered.",
    ready_for_pickup: "Your order is ready for pickup.",
    in_transit: "Your order is in transit.",
    out_for_delivery: "Your order is out for delivery.",
  };

  const formattedCreated = `on ${days[createdAt.getDay()]}, ${createdAt.getDate()} ${months[createdAt.getMonth()]}`;
  const fromDate = addDays(createdAt, 10);
  $("#delivered_by").text(formatDate(fromDate));

  let orderStatusHTML = `
    <li class="pannel-tab confirm">
      <div class="panel-heading"><h3>Order Received</h3></div>
      <div class="panel-content"><p>Your order has been received <b>${formattedCreated}</b></p></div>
    </li>`;

  orderStatusHTML += status_history
    .map((status) => {
      const {
        title,
        created_at,
        is_occured,
        is_active,
        ref_key,
        summary,
        video_link,
        image_link,
      } = status;

      // If the order contains a gift-card product (digital or physical),
      // only "Order Received" (rendered above, outside this loop) and
      // "Order Dispatched" should show.
      const hide = isGiftCardOrder
        ? title !== "Order Dispatched"
        : areAllReadyMade && statusToRemove.includes(ref_key);
      if (hide) return "";

      const formattedDate =
        is_occured && created_at
          ? `on ${days[new Date(created_at).getDay()]}, ${new Date(created_at).getDate()} ${months[new Date(created_at).getMonth()]}`
          : "";

      const isBlocked = !summary ? "blocked" : "";
      const disabled = !is_occured || !summary ? "disabled" : "";

      // A digital gift card is emailed, never packed/dispatched for real, so
      // the "Order Dispatched" status's video (a packing/shipping clip) is
      // never relevant for one — suppress it for that title on digital gift
      // orders. Physical gift-card orders still ship, so they keep it.
      const isDigitalDispatch = title === "Order Dispatched" && hasDigitalGiftProduct;
      const suppressVideo = isDigitalDispatch;
      const videoHTML =
        video_link && !suppressVideo
          ? `<br><iframe width="100%" height="315" src="https://www.youtube.com/embed/${getYouTubeID(video_link)}?autoplay=1&mute=1" allowfullscreen></iframe>`
          : "";
      const imageHTML = image_link
        ? `<br><img src="${image_link}" alt="status image">`
        : "";

      const dispatchDate =
        title === "Order Dispatched" && created_at
          ? new Date(created_at)
          : null;
      // Digital gift cards aren't "dispatched" — they're sent by email — so
      // this status gets its own copy instead of the generic shipping one.
      const dispatchTitle = dispatchDate
        ? isDigitalDispatch
          ? `Your Digital Gift Card was sent on ${dispatchDate.getDate()} ${months[dispatchDate.getMonth()]} ${dispatchDate.getFullYear()}`
          : `Your Order Dispatched on ${dispatchDate.getDate()} ${months[dispatchDate.getMonth()]} ${dispatchDate.getFullYear()}`
        : title;
      const dispatchSummary = isDigitalDispatch
        ? "Your gift card has been sent to the recipient’s email address and is ready to use online at The Pant Project."
        : summary;

      return `
      <li class="pannel-tab ${is_occured ? "confirm" : ""} ${is_active && !shipmentStatus ? "active" : ""}">
        <div class="panel-heading ${isBlocked}" ${disabled}>
          <h3>${dispatchTitle}</h3>
        </div>
        <div class="panel-content">
          <p>${dispatchSummary || ""}<br><b>${formattedDate}</b></p>
          ${videoHTML}${imageHTML}
        </div>
      </li>`;
    })
    .join("");

  if (shipmentStatus && !isGiftCardOrder) {
    orderStatusHTML += `
    <li class="pannel-tab confirm active" style="padding: 10px;">
      <div class="panel-heading">
        <h3 style="text-transform:capitalize;">${shipmentStatus?.replace(/_/g, " ")}</h3>
      </div>
      <div class="panel-content">
        <p>${shippingStatusContent[shipmentStatus] || ""}</p>
      </div>
    </li>`;
  }

  $("#order_status_items").html(orderStatusHTML);

  $(".toggle-btn").on("click", function () {
    $(this).toggleClass("open");
    $(this).next(".order-customisation").slideToggle();
    $(this).text(
      $(this).hasClass("open") ? "Close customisations" : "See customisations",
    );
  });

  $(".confirm .panel-heading").on("click", function () {
    if ($(this).is("[disabled]")) return;
    const $this = $(this);
    const $parent = $this.closest(".confirm");
    $parent.siblings().find(".panel-content").slideUp();
    $parent.siblings().find(".panel-heading").removeClass("open");
    $this.toggleClass("open");
    $this.next(".panel-content").slideToggle();
  });

  $(".top-accordian-wrap h2").on("click", function () {
    $(".top-accordian-wrap-panel").slideToggle();
    $(this).toggleClass("open");
  });
});
